'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cardNumber = require('./payments/card-number');

var _cardNumber2 = _interopRequireDefault(_cardNumber);

var _cardExpiration = require('./payments/card-expiration');

var _cardExpiration2 = _interopRequireDefault(_cardExpiration);

var _cardSecurityCode = require('./payments/card-security-code');

var _cardSecurityCode2 = _interopRequireDefault(_cardSecurityCode);

var _unifiedCreditCard = require('./payments/unified-credit-card');

var _unifiedCreditCard2 = _interopRequireDefault(_unifiedCreditCard);

var _cardSet = require('./payments/card-set');

var _cardSet2 = _interopRequireDefault(_cardSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Payments = {
  CardNumber: _cardNumber2.default,
  CardExpiration: _cardExpiration2.default,
  CardSecurityCode: _cardSecurityCode2.default,
  UnifiedCreditCard: _unifiedCreditCard2.default,
  CardSet: _cardSet2.default
}; /**
    * # Payment Inputs
    * Input containers for payment details.
    *
    * @module components/payments.js
    */

exports.default = Payments;
module.exports = exports['default'];
//# sourceMappingURL=payments.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/components/payments.js
// module id = 854
// module chunks = 0